import { render, staticRenderFns } from "./varModel.vue?vue&type=template&id=24424c3e&"
import script from "./varModel.vue?vue&type=script&lang=js&"
export * from "./varModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports